export default __webpack_public_path__ + "static/media/Datacor_Company_Logo_RGB_Icon.8778e773.png";